/* eslint-disable */
import { scrollToPos } from "./chc/helpers";

document.addEventListener('alpine:init', () => {
    Alpine.data('quicklinksV2', () => ({
        initLoad: true,
        showQuicklinks: false,
        openDropdown: false,
        showDropdown: false,
        desktopShowDropdown: null,
        linkListWidth: 0,
        itemArr: null,
        activeLink: null,
        quicklinksListEl: null,
        currScrollY: 0,
        parentHeight: 0,
        dropdownListHeight: null,

        _activeAnchor: "",

        anchorList: [],
        ifListEntered: false,
        get storeSection() {
            return this.$store.sectionId;
        },
        get activeAnchor() {
            // const activeSection = this.$store.sectionId.activeSection;
            // const activeAnchor = this.anchorList.find(anchor => anchor == activeSection);
            const activeAnchor = this.storeSection.getLastIntersectSection(this.anchorList);
            if (activeAnchor) this._activeAnchor = activeAnchor;
            else this._activeAnchor = null;

            return this._activeAnchor;
        },
        get progress() {
            const index = this.anchorList.indexOf(this._activeAnchor);
            const multiplier = 100 / this.anchorList.length;
            const width = multiplier * (index + 1);

            if (this.ifLastItemActive) return `100%`;
            if (!this.storeSection.isEntered) return "0%";
            return `${width}%`;
        },
        get detectIntersect() {
            const anchorList = this.storeSection.anchorList;
            let bool = [];
            anchorList.forEach(item => {
                bool.push(document.getElementById(`quicklinksV2--${item}`).classList.contains("entered"));
            });
            return bool.includes(true);
        },
        get ifLastItemActive() {
            const anchorList = this.storeSection.anchorList;
            const currActive = this._activeAnchor;
            const lastItem = anchorList[anchorList.length - 1];
            return lastItem === currActive;
        },

        scrollToPosition: id => scrollToPos(id),
        setInit(bool, isEditMode) {
            this.parentHeight = this.$root.clientHeight;
            this.$refs.dropdown.classList.remove("hidden");
            this.$refs.svgArrow.classList.remove("rotate-90");

            this.linkListWidth = this.$refs.horizontalList.scrollWidth;
            this.setDropdown();
            this.setQuicklinks(bool);
            if (!isEditMode) this.setSpacing(bool);

            window.addEventListener("resize", () => {
                this.reInit();
                this.setDropdown();
            });
            
        },
        reInit() {
            const linkList = this.$refs?.linkList;
            const qTitle = this.$refs?.qTitle;

            this.desktopShowDropdown = false;
            this.showDropdown = false;
            
            if (this.itemArr && linkList.children.length === 0) this.itemArr.forEach(el => linkList.appendChild(el));

            linkList.classList.remove("hidden");
            linkList.classList.remove("opacity-0");
            qTitle.classList.remove("cursor-pointer");

            this.linkListWidth = this.$refs.horizontalList.scrollWidth;
        },
        get ifMobile() {
            let check = false;
            (function(a){
                if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        },
        getShortestSize(items) {
            let shortest = null;

            items.forEach(el => {
                if (!shortest) shortest = el.clientWidth;
                if (el.clientWidth < shortest) shortest = el.clientWidth;
            });

            return shortest;
        },
        get getCurrMenu() {
            const horizontalList = this.$refs.horizontalList;
            const dropdownList = this.$refs.dropdown;
            const currMenu = horizontalList.querySelectorAll("li").length ? horizontalList : dropdownList;

            return currMenu;
        },
        getLiData(el) {
            const items = el.querySelectorAll("li");
            const anchors = el.querySelectorAll("li a");
            const progressbar = el.querySelector(".quicklinksV2__progressbarThumb");
            const len = items.length;
            const multiplyTo = 100/len;

            return [items, anchors, progressbar, multiplyTo];
        },
        setSpacing(bool) {
            const stickyNavOverlaySpacer = document.querySelector(".sticky-nav-overlay-spacer");
            const stickyNavOverlaySpacerheight = stickyNavOverlaySpacer ? stickyNavOverlaySpacer.clientHeight : 0;
            const spacerHeight = this.$el.classList.contains("quicklinksV2--float")? 0 : stickyNavOverlaySpacerheight;

            if (bool && stickyNavOverlaySpacer) stickyNavOverlaySpacer.style.height = `${spacerHeight - this.$el.clientHeight}px`;
        },
        setQuicklinks(bool) {
            this.showQuicklinks = !bool;

            this.$el.classList.remove("opacity-0");
            if (bool) window.addEventListener("scroll", () => this.scrollEvent());
        },
        setActiveClasses(quicklinks, el, activeClasses) {
            const { normalColor, activeColor } = quicklinks.dataset;
            
            if (normalColor !== activeColor) {
                el.querySelector("a").classList.remove(normalColor);
                el.querySelector("a").classList.add(activeColor);
            }

            el.querySelector("a").classList.add(...activeClasses);
        },
        setActive(id) {
            this.storeSection.addSection(id);
        },
        setActiveLeave(id) {
            this.storeSection.removeSection(id);
        },
        setActiveItem() {
            const activeClasses = [ "active", "font-bold" ];
            const currMenu = this.getCurrMenu;

            if (!currMenu) return;

            currMenu.querySelectorAll("li a").forEach(el => el.classList.remove(...activeClasses));
            this.$el.classList.add(...activeClasses);
        },
        setDropdown() {
            const linkList = this.$refs?.linkList;
            const linkItems = linkList.querySelectorAll("li");
            const btnArea = this.$refs?.btnArea ? (this.$refs?.btnArea.clientWidth + 16) : 1;
            const linkListWidth  = this.linkListWidth - btnArea;
            const isMobileTablet = this.ifMobile;
            let itemsWidth = 0;

            linkItems.forEach(el => el.classList.add("whitespace-nowrap"));
            itemsWidth = this.$refs?.widthBase ? this.$refs?.widthBase.clientWidth : 0;

            const showDropdown = itemsWidth > linkListWidth;
            const wWidth = window.innerWidth;
            
            if ((wWidth > 1024 || !isMobileTablet) && !this.desktopShowDropdown) this.desktopShowDropdown = showDropdown;

            if (!this.itemArr) this.itemArr = Array.prototype.slice.call(linkItems);

            if ((showDropdown || this.desktopShowDropdown) || (wWidth < 1025 || isMobileTablet)) {
                this.showDropdown = true;
                const qTitle = this.$refs?.qTitle;
                const dropdown  = this.$refs?.dropdown;
                const dropdownUl = dropdown.querySelector("ul");

                qTitle.classList.add("cursor-pointer");
                linkList.classList.add("hidden");

                if (this.itemArr && dropdownUl.children.length === 0) this.itemArr.forEach(el => dropdownUl.appendChild(el));
            } else {
                this.openDropdown = false;
                this.$refs.bgQuicklinks.classList.remove("rounded-b-none");
                this.reInit();
                this.setBlurEffect();
            }
        },
        setBlurEffect() {
            const _parent = this.$root;
            const parentHeight = this.parentHeight;
            const dropdown = this.$refs.dropdown;

            if (!this.showDropdown) {
                _parent.style.height = `${parentHeight}px`;
                return;
            }

            setTimeout(() => {
                const dropdownHeight = this.openDropdown ? dropdown.clientHeight : 0;
                _parent.style.height = `${parentHeight + dropdownHeight}px`;
            }, 10);
        },
        progressbarAnimation(len) {
            const key = Number(this.$el.dataset.key) + 1;
            const multiplyTo = 100/len;
            
            this.$refs.progressbar.style.width = `${multiplyTo * key}%`;
        },
        openDropdownEvent() {
            const _parent = this.$root;
            const dropdown = this.$refs.dropdown;
            const dropdownLi = dropdown.querySelectorAll("li");

            if (!dropdownLi.length) return;
            
            this.openDropdown = !this.openDropdown;
            
            this.setBlurEffect();
            
            if (_parent.classList.contains("quicklinksV2--float") && this.openDropdown) this.$refs.bgQuicklinks.classList.add("rounded-b-none");
            else this.$refs.bgQuicklinks.classList.remove("rounded-b-none");
        },
        scrollEvent() {
            const windowHeight = window.innerHeight;
            const fullHeight = document.body.clientHeight;
            const scrolled = window.scrollY;
            const percentScrolled = (scrolled / (fullHeight - windowHeight)) * 100;
            // Hide and Show all of Quicklinks
            this.showQuicklinks = percentScrolled > 4;
        },
        
        observeBak(id) {
            const navigation = document.getElementById("quicklinksV2--navigation");
            if (!navigation) return;

            const { right: sectionRight, left: sectionLeft, top: sectionTop, bottom: sectionBottom } = this.$root.getBoundingClientRect();
            const { right: anchorRight, left: anchorLeft, top: anchorTop, bottom: anchorBottom } = navigation.getBoundingClientRect();
            const anchorBottomWithBuffer = anchorBottom + 100;
            const isIntersecting =
                !(sectionRight < anchorLeft ||
                  sectionLeft > anchorRight ||
                  sectionBottom < anchorTop ||
                  sectionTop > anchorBottomWithBuffer);
            
            const isVisible = sectionTop <= anchorBottomWithBuffer && sectionBottom >= anchorBottomWithBuffer;

            if (isIntersecting && isVisible) this.storeSection.addIntersectSection(id);       
        },
        observe(id) {
            const anchorList = this.storeSection.anchorList;
            if (anchorList.length === 0 || anchorList.find(anchor => anchor == id)) {
                const { top: sectionTop, bottom: sectionBottom } = this.$root.getBoundingClientRect();
                if (sectionTop >= 0 && sectionTop <= (window.innerHeight * 0.35)) this.storeSection.addIntersectSection(id);
            }
            this.storeSection.isEntered = this.detectIntersect;
        },
        initSection(id) {
            this.storeSection.addSection(id);
            this.observe(id);
        },
        isActive(id) {
            return (this.activeAnchor === id || id === this.storeSection.activeSection) && this.storeSection.isEntered;
        },
    }));
});